module.exports = __webpack_public_path__ + "static/1-bb954865fc827fed7eb27f23af793f25.jpg";